// The Claude split chrome around a real registration stage.
//
// THE DIAL DOES NOT DECIDE ANYTHING HERE. Registration still runs through
// flow.ts. This file only puts that stage in the left column of the visitor
// Wheel surface so /w/ matches the design kit instead of the ordinary /j/ page.

import { useMemo, type ReactNode } from "react";
import { SHIPPED_SYSTEM, Wheel, WheelLogo, segmentFromLabel, type VisitorLogo, type WheelLane } from "@nova/xp-visitor";
import type { PageTheme } from "./theme.js";

export function WheelFrame({
  slices,
  mode,
  lane,
  logo,
  children,
}: {
  readonly slices: readonly { readonly id: string; readonly label: string }[];
  readonly mode: PageTheme;
  readonly lane: WheelLane;
  readonly logo?: VisitorLogo;
  readonly children: ReactNode;
}): ReactNode {
  const segments = useMemo(() => segmentsFrom(slices), [slices]);
  return (
    <div className="web-wheel">
      <Wheel
        lane={lane}
        system={SHIPPED_SYSTEM}
        mode={mode}
        segments={segments}
        showLabels
        showFooter={false}
        interactive={false}
        {...(logo === undefined ? {} : { logo })}
        copyColumn={
          <div className="col">
            <WheelLogo logo={logo ?? { src: null, name: "Nova" }} />
            {children}
          </div>
        }
      />
    </div>
  );
}

export function visitorLogoFrom(
  logos: { readonly light?: string; readonly dark?: string } | null,
  theme: PageTheme,
  name = "Client",
): VisitorLogo {
  if (logos === null) return { src: null, name: "Nova" };
  const src = theme === "dark" ? (logos.dark ?? logos.light) : (logos.light ?? logos.dark);
  return { src: src ?? null, name };
}

function segmentsFrom(slices: readonly { readonly id: string; readonly label: string }[]) {
  const rows = slices.length >= 4 ? slices : Array.from({ length: 8 }, (_, i) => ({ id: `s${i + 1}`, label: "" }));
  return rows.map((row) => segmentFromLabel(row.id, row.label));
}
